import { confirmIncludeWeekday } from "./ConfirmMessageBoxes";
import { fiflboxApi } from '@/utils/api';

export default {
	methods: {
		async askBeforeCreateChildCourse() {
			if (!this.form.is_offline){
				let is_url_validate = true;
				if(!this.form.online_course_url){
					this.$message('양식을 빠짐없이 채워주세요');
					return 'STOP-MODIFY';
				}
				else{
					this.$refs['childCourseForm'].validate((valid)=>{
						is_url_validate = valid;
					})
				}

				if(!is_url_validate){
					return 'STOP-MODIFY';
				}
			}

			let thisWeekday = this.getDayOfWeek(this.form.dt);

			if (
				this.recurrenceForm.frequency != 0 &&
				!this.recurrenceForm.weekdays.includes(thisWeekday)
			) {
				let isIncludingWeekday = await confirmIncludeWeekday();

				if (!isIncludingWeekday) {
					return "STOP-MODIFY";
				}

				this.recurrenceForm.weekdays.push(thisWeekday);
			}
		},
		async createChildCourse() {
			let result = await this.askBeforeCreateChildCourse();
			if (result === "STOP-MODIFY") {
				return false;
			}

			let form = Object.assign({}, this.form);

			if (this.recurrenceForm.frequency != 0) {
				form.recurrence = this.vaildateRecurrenceForm(this.recurrenceForm);
			}

			form.start = this.joinDatetime(
				this.presentData.day,
				this.presentData.time
			);

			try {
        await fiflboxApi.v2.postChildCourses(form);

				return true;
			} catch (err) {
				if (err.response.status === 400) {
					this.$message("양식을 빠짐없이 채워주세요.");
				} else {
					this.$message("알 수 없는 오류입니다.");
				}

				return false;
			}
		},
	}
}